import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import ProceduresTable from './components/ProceduresTable';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const Procedures = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const [proceduresData, setProceduresData] = useState([]);
  const [loading, setLoading] = useState(true);

  // const fetchProcedures = async () => {
  //   try {
  //     const response = await createAPIEndPoint(`procedure/get_all/${clinic_id}`).fetchAll();
  //     setProceduresData(response.data.procedures || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching procedures');
  //     if (err?.response?.data?.error?.includes('Bearer token')) {
  //       logoutUser(navigate);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProcedures = async () => {
    setLoading(true);

    try {
      const response = await createAPIEndPoint(
        `procedure/get_all/${clinic_id}`,
      ).fetchAll();

      const procedures = response.data.procedures || [];

      // Latest first by created_at
      const sortedProcedures = procedures.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      setProceduresData(sortedProcedures);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching procedures');

      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProcedures();
  }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <ProceduresTable
        tableData={proceduresData}
        loading={loading}
        fetchAgain={fetchProcedures}
      />{' '}
    </Box>
  );
};

export default Procedures;
